import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { creditNoteQueryOptions } from '../../../../features/sales/queries'

export const Route = createFileRoute('/_app/credit-notes/$creditNoteId')({
  staticData: { crumb: 'creditNote' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(creditNoteQueryOptions(params.creditNoteId)),
  component: Outlet,
})
